import { StateToken } from '@ngxs/store';
import { MessagesExtensionsFR } from './app.config.types';

export const SCREEN_SIZE_WIDTHS = {
  SMALL: '(max-width: 779px)',
  MEDIUM: '(min-width: 780px) and (max-width: 999px)',
  LARGE: '(min-width: 1000px)',
};
export type SCREEN_SIZE = 'SMALL' | 'MEDIUM' | 'LARGE';

export interface AppStateModel {
  widthScreen: number;
  showLoader: number;
  screenWidthSize: SCREEN_SIZE;
  userInfos: any;
  messagesExtensionsFrontReader: MessagesExtensionsFR;
}

export const APP_STATE_TOKEN = new StateToken<AppStateModel>('appState');
export const INITIAL_APP_STATE: AppStateModel = {
  widthScreen: 0,
  showLoader: 0,
  screenWidthSize: 'LARGE',
  userInfos: null,
  messagesExtensionsFrontReader: {},
};
